(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8249],{

/***/ 49312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tm-detail/[code]",
      function () {
        return __webpack_require__(85264);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sM": function() { return /* binding */ ContactQQLink; }
/* harmony export */ });
/* unused harmony export createContactQQLink */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96618);



var ContactQQLink = "http://wpa.qq.com/msgrd?v=3&uin=2850451486&site=qq&menu=yes";
function createContactQQLink(qq) {
    return "http://wpa.qq.com/msgrd?v=3&uin=".concat(qq, "&site=qq&menu=yes");
}
var ContactQQ = function(props) {
    return /*#__PURE__*/ _jsx(HYLink, {
        target: "_blank",
        href: ContactQQLink,
        children: props.children
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ContactQQ)));


/***/ }),

/***/ 70521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



var HYHead = function(props) {
    var _title = props.title, title = _title === void 0 ? "天猫-京东-抖音-全电商平台入驻-网店代运营" : _title, _disableSuffix = props.disableSuffix, disableSuffix = _disableSuffix === void 0 ? false : _disableSuffix, _description = props.description, description = _description === void 0 ? "汇蚁网专业的电商服务平台专营京东自营、京东慧采店铺代入驻服务,以及京东自营,慧采,天猫店,淘宝店,抖小店,拼多多等众多电商平台的网店代运营及商标买卖服务,欢迎咨询" : _description, _keywords = props.keywords, keywords = _keywords === void 0 ? "天猫入驻,京东入驻,慧采入驻,拼多多入驻,抖小店入驻,店铺代运营,商标转让,商标注册" : _keywords;
    var titleSuffix = disableSuffix ? "" : "-汇蚁网";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title + titleSuffix
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HYHead);


/***/ }),

/***/ 36440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _common_app_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30624);
/* harmony import */ var _common_components_link_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96618);
/* harmony import */ var _common_tools_kst__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5780);
/* harmony import */ var _modules_tm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52188);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16536);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98977);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11382);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49571);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_11__);










var Api = _modules_tm__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Api */ .Z.Api;
var TMTransferListItem = function(props) {
    var hasLogin = props.hasLogin, model = props.model;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isLogin = ref[0], setIsLogin = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), modalVisible = ref2[0], setModalVisible = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(), sameData = ref3[0], setSameData = ref3[1];
    var photo = model.extend.photo;
    if (model.renderPhoto) photo = model.renderPhoto;
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        setIsLogin(hasLogin);
    }, [
        hasLogin
    ]);
    // ------------------- Request -------------------
    // 获取同名商标
    var request = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setLoading(true);
                    return [
                        4,
                        Api.sameName(model.name)
                    ];
                case 1:
                    response = _state.sent();
                    setLoading(false);
                    if (!response.success) {
                        antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"].error */ .ZP.error(response.errorDescribe);
                        return [
                            2
                        ];
                    }
                    setSameData(response.model.list);
                    return [
                        2
                    ];
            }
        });
    }), [
        model
    ]);
    // ------------------- Events -------------------
    // 点击 - 登录获取价格
    var onTapLogin = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(e) {
        e.preventDefault();
        e.stopPropagation();
        window.open(_common_app_router__WEBPACK_IMPORTED_MODULE_1__/* ["default"].User.login */ .Z.User.login({
            redirect: window.location.href
        }));
    }, []);
    // 点击 - 立即议价
    var onTapContact = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(e) {
        e.preventDefault();
        e.stopPropagation();
        _common_tools_kst__WEBPACK_IMPORTED_MODULE_8__/* ["default"].call */ .Z.call();
    }, []);
    // 点击 - 多类别
    var onTapSameName = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(e) {
        e.preventDefault();
        e.stopPropagation();
        setModalVisible(true);
        if (!sameData && !loading) {
            request();
        }
    }, [
        sameData,
        loading,
        request
    ]);
    // 同名多类Modal取消
    var onModalCancel = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        setModalVisible(false);
    }, []);
    // ------------------- UI -------------------
    var modal = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        width: 700,
        bodyStyle: {
            padding: 0
        },
        centered: true,
        destroyOnClose: true,
        closable: false,
        open: modalVisible,
        onCancel: onModalCancel,
        footer: null,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            spinning: loading,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().modalContainer), " flex-col flex-cross-axis-center"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().title),
                        children: "".concat(model.name, " - 同名商标")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-row-wrap flex-main-axis-center",
                        children: (sameData !== null && sameData !== void 0 ? sameData : []).map(function(item, index) {
                            var photo = item.extend.photo;
                            if (item.renderPhoto) photo = item.renderPhoto;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_common_components_link_link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                target: "_blank",
                                className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().card), " flex-col flex-cross-axis-center"),
                                href: _common_app_router__WEBPACK_IMPORTED_MODULE_1__/* ["default"].TM.detail */ .Z.TM.detail(item.code),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: photo,
                                        alt: item.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().category),
                                        children: item.uiCategory
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().scope),
                                        children: item.uiScope
                                    }),
                                    hasLogin ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().price),
                                        children: item.uiPrice
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().getPrice),
                                        onClick: onTapLogin,
                                        children: "登录获取价格"
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_common_components_link_link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        target: "_blank",
        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().item), " flex-col"),
        href: _common_app_router__WEBPACK_IMPORTED_MODULE_1__/* ["default"].TM.detail */ .Z.TM.detail(model.code),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().content), " flex-col"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-row-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().logo),
                            style: {
                                backgroundImage: "url(".concat(photo, ")")
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().nameContainer), " flex-row flex-main-axis-between flex-cross-axis-center"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().name)),
                                children: model.uiName
                            }),
                            model.duplicateCount > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().tag),
                                onClick: onTapSameName,
                                children: "多类别"
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().desc),
                        children: model.uiScope
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().row4),
                        children: hasLogin && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().price),
                            children: model.uiPrice
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().buttonContainer), " flex-row flex-main-axis-between"),
                children: [
                    !hasLogin && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().getPrice), " flex-row-center"),
                        onClick: onTapLogin,
                        children: "登录查价"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().contactNow), " flex-row-center"),
                        onClick: function(e) {
                            return onTapContact(e);
                        },
                        children: "立即询价"
                    })
                ]
            }),
            modal
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TMTransferListItem);


/***/ }),

/***/ 18982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35854);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _modules_tm_assets_transfer_find_more_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59161);
/* harmony import */ var _modules_tm_assets_transfer_find_more_png__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modules_tm_assets_transfer_find_more_png__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modules_tm_assets_transfer_icon_client_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95406);
/* harmony import */ var _modules_tm_assets_transfer_icon_client_png__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_modules_tm_assets_transfer_icon_client_png__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _modules_tm_assets_transfer_icon_global_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73518);
/* harmony import */ var _modules_tm_assets_transfer_icon_global_png__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_modules_tm_assets_transfer_icon_global_png__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _common_tools_kst__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5780);







var TMTransferNotFound = function(props) {
    // --------------- Events ---------------
    // 联系客服
    var onTapClient = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        _common_tools_kst__WEBPACK_IMPORTED_MODULE_5__/* ["default"].call */ .Z.call();
    }, []);
    // 国际商标
    var onTapInternational = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        _common_tools_kst__WEBPACK_IMPORTED_MODULE_5__/* ["default"].call */ .Z.call();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container), " flex-row flex-cross-axis-center"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().logo),
                src: (_modules_tm_assets_transfer_find_more_png__WEBPACK_IMPORTED_MODULE_2___default()),
                alt: "notfound"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().infoContainer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: "不要急哦，好多好商标没有展示出来，马上联系服务顾问获取！"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: "没有找到您心仪的商标？"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btnContainer), " flex-row"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btn), " flex-row-center"),
                                onClick: onTapClient,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().icon),
                                        src: (_modules_tm_assets_transfer_icon_client_png__WEBPACK_IMPORTED_MODULE_3___default()),
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "联系客服"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btn), " flex-row-center"),
                                onClick: onTapInternational,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().icon),
                                        src: (_modules_tm_assets_transfer_icon_global_png__WEBPACK_IMPORTED_MODULE_4___default()),
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "国际商标"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TMTransferNotFound);


/***/ }),

/***/ 46021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _modules_tm__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52188);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _list_item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36440);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34418);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var TMTransferRecommend = function(props) {
    var hasLogin = props.hasLogin;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), initOk = ref[0], setInitOk = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), dataSource = ref1[0], setDataSource = ref1[1];
    var request = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var ref, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _modules_tm__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Api.recommend */ .Z.Api.recommend()
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.success) {
                        return [
                            2
                        ];
                    }
                    setDataSource((ref = response.model) === null || ref === void 0 ? void 0 : ref.list);
                    return [
                        2
                    ];
            }
        });
    }), []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (initOk) return;
        request().then(function() {
            setInitOk(true);
        });
    }, [
        initOk,
        request
    ]);
    if (!dataSource || dataSource.length === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex-row flex-cross-axis-end",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: "精品推荐"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: "没有找到想要的商标，您还可以看看这些商标"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().listContainer), " flex-row-wrap"),
                children: dataSource.map(function(item, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_list_item__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        model: item,
                        hasLogin: hasLogin
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TMTransferRecommend);


/***/ }),

/***/ 24660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23749);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var TMSearchTopInfo = function(props) {
    // TODO:
    //const fakeData = useGetDynamicData().data;
    // 单个信息Item
    var createInfo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(icon, title, value) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().infoItem), " flex-row flex-cross-axis-center"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().icon),
                    src: icon,
                    alt: ""
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().value),
                    children: value
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().arrow)
                })
            ]
        });
    }, []);
    // 左侧信息
    var infos = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex-row"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: props.style,
        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container), " flex-row flex-main-axis-between"),
        children: infos
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TMSearchTopInfo);


/***/ }),

/***/ 85264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TMDetailCtx": function() { return /* binding */ TMDetailCtx; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _code_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/HomeOutlined.js + 1 modules
var HomeOutlined = __webpack_require__(73403);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 3 modules
var message = __webpack_require__(16536);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js
var spin = __webpack_require__(11382);
// EXTERNAL MODULE: ./node_modules/antd/es/breadcrumb/index.js + 47 modules
var breadcrumb = __webpack_require__(18080);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./pages/tm-detail/index.module.scss
var index_module = __webpack_require__(64460);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./modules/tm/index.tsx + 3 modules
var tm = __webpack_require__(52188);
// EXTERNAL MODULE: ./modules/tm/api/tm/tm-model.ts
var tm_model = __webpack_require__(51566);
// EXTERNAL MODULE: ./common/redux/index.ts + 17 modules
var redux = __webpack_require__(61912);
// EXTERNAL MODULE: ./common/components/head/index.tsx
var head = __webpack_require__(70521);
// EXTERNAL MODULE: ./common/app/router.ts
var app_router = __webpack_require__(30624);
// EXTERNAL MODULE: ./modules/tm/components/transfer/not-found/index.tsx
var not_found = __webpack_require__(18982);
// EXTERNAL MODULE: ./modules/tm/components/transfer/recommend/index.tsx
var recommend = __webpack_require__(46021);
// EXTERNAL MODULE: ./modules/tm/components/transfer/search-panel/components/top-info/index.tsx
var top_info = __webpack_require__(24660);
// EXTERNAL MODULE: ./modules/tm/defines/tm-defines.ts
var tm_defines = __webpack_require__(78692);
// EXTERNAL MODULE: ./modules/tm/components/detail/header-info/index.module.scss
var header_info_index_module = __webpack_require__(70311);
var header_info_index_module_default = /*#__PURE__*/__webpack_require__.n(header_info_index_module);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 3 modules
var tooltip = __webpack_require__(84908);
// EXTERNAL MODULE: ./modules/tm/components/detail/header-info/info-area/index.module.scss
var info_area_index_module = __webpack_require__(74337);
var info_area_index_module_default = /*#__PURE__*/__webpack_require__.n(info_area_index_module);
// EXTERNAL MODULE: ./modules/tm/assets/detail/negotiate-price.png
var negotiate_price = __webpack_require__(33984);
var negotiate_price_default = /*#__PURE__*/__webpack_require__.n(negotiate_price);
// EXTERNAL MODULE: ./modules/tm/assets/detail/price-white.png
var price_white = __webpack_require__(83285);
var price_white_default = /*#__PURE__*/__webpack_require__.n(price_white);
// EXTERNAL MODULE: ./common/tools/kst/index.ts
var kst = __webpack_require__(5780);
;// CONCATENATED MODULE: ./modules/tm/components/detail/header-info/info-area/index.tsx










var TMDetailInfoArea = function(props) {
    var code = props.code, category = props.category, subCategory = props.subCategory;
    // ---------------- Data ----------------
    // 分类
    var categoryValue = (0,react.useMemo)(function() {
        var cValue = category >= 10 ? "".concat(category, "类") : "0".concat(category, "类");
        return cValue + "-" + tm_defines/* default.Categories */.ZP.Categories[category - 1];
    }, [
        category
    ]);
    // 用途参考
    var subCategoryUse = (0,react.useMemo)(function() {
        return subCategory.reduce(function(previous, current) {
            return previous + " " + current.name;
        }, "");
    }, [
        subCategory
    ]);
    // 类似群组
    var subCategoryCode = (0,react.useMemo)(function() {
        // 过滤相同的值
        var set = new Set();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = subCategory[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var obj = _step.value;
                set.add(obj.code);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var value = "";
        set.forEach(function(v) {
            value += v;
            value += " ";
        });
        return value;
    }, [
        subCategory
    ]);
    // ---------------- Events ----------------
    // 点击了立即咨询
    var onTapContact = (0,react.useCallback)(function() {
        kst/* default.call */.Z.call();
    }, []);
    // ---------------- UI ----------------
    var uiCategory = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((info_area_index_module_default()).info, " flex-row"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (info_area_index_module_default()).title,
                children: "商标分类："
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (info_area_index_module_default()).value,
                children: categoryValue
            })
        ]
    });
    var uiSubCategoryUse = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((info_area_index_module_default()).info, " flex-row"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (info_area_index_module_default()).title,
                children: "用途参考："
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    flex: 1
                },
                className: "flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                        title: subCategoryUse,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (info_area_index_module_default()).value,
                            children: subCategoryUse
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (info_area_index_module_default()).notice,
                        children: "温馨提示：以上适用项目仅供参考，详情请咨询顾问"
                    })
                ]
            })
        ]
    });
    var uiSubCategoryCode = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((info_area_index_module_default()).info, " flex-row"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (info_area_index_module_default()).title,
                children: "类似群组："
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                title: subCategoryCode,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (info_area_index_module_default()).value,
                    children: subCategoryCode
                })
            })
        ]
    });
    var createButton = (0,react.useCallback)(function(param) {
        var icon = param.icon, title = param.title, btnClass = param.btnClass, onTap = param.onTap;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((info_area_index_module_default()).button, " ").concat(btnClass, " flex-row-center"),
            onClick: onTap,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: icon,
                    alt: ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: title
                })
            ]
        });
    }, []);
    var buttonArray = /*#__PURE__*/ (0,jsx_runtime.jsx)(TMDetailCtx.Consumer, {
        children: function(value) {
            var state = value.state, onTapBuy = value.onTapBuy;
            var noLogin = true;
            if (state && state.token && state.token.length > 0) {
                noLogin = false;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((info_area_index_module_default()).buttonContainer, " flex-row"),
                children: [
                    createButton({
                        icon: (negotiate_price_default()),
                        title: "立即咨询",
                        btnClass: (info_area_index_module_default()).buttonContact,
                        onTap: onTapContact
                    }),
                    createButton({
                        icon: (price_white_default()),
                        title: "立即购买",
                        btnClass: (info_area_index_module_default()).buttonBuy,
                        onTap: function() {
                            // 未登录，先跳转你登录
                            if (noLogin) {
                                var redirect = window.location.href;
                                window.location.href = window.location.origin + app_router/* default.User.login */.Z.User.login({
                                    redirect: redirect
                                });
                            } else {
                                onTapBuy === null || onTapBuy === void 0 ? void 0 : onTapBuy(code);
                            }
                        }
                    })
                ]
            });
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (info_area_index_module_default()).container,
        children: [
            uiCategory,
            uiSubCategoryUse,
            uiSubCategoryCode,
            buttonArray
        ]
    });
};
/* harmony default export */ var info_area = (TMDetailInfoArea);

// EXTERNAL MODULE: ./modules/tm/components/detail/header-info/person-area/index.module.scss
var person_area_index_module = __webpack_require__(38146);
var person_area_index_module_default = /*#__PURE__*/__webpack_require__.n(person_area_index_module);
// EXTERNAL MODULE: ./modules/tm/assets/detail/wechat.png
var wechat = __webpack_require__(91585);
var wechat_default = /*#__PURE__*/__webpack_require__.n(wechat);
// EXTERNAL MODULE: ./modules/tm/assets/detail/chat.png
var chat = __webpack_require__(67627);
var chat_default = /*#__PURE__*/__webpack_require__.n(chat);
// EXTERNAL MODULE: ./public/logo512.png
var logo512 = __webpack_require__(82064);
var logo512_default = /*#__PURE__*/__webpack_require__.n(logo512);
// EXTERNAL MODULE: ./node_modules/antd/es/popover/index.js
var popover = __webpack_require__(55241);
// EXTERNAL MODULE: ./common/defines/ali-oss.ts
var ali_oss = __webpack_require__(78710);
// EXTERNAL MODULE: ./common/components/contact-qq/index.tsx
var contact_qq = __webpack_require__(30305);
;// CONCATENATED MODULE: ./modules/tm/components/detail/header-info/person-area/index.tsx









var ossGen = (0,ali_oss/* getOssAssetsGenerator */.Ah)("kst/");
var TMDetailPersonArea = function(props) {
    // ---------------- Events ----------------
    // 点击 - 在线咨询
    var onTapContact = (0,react.useCallback)(function() {
        window.open(contact_qq/* ContactQQLink */.sM);
    }, []);
    // ---------------- UI ----------------
    var noAvatar = !props.avatar || props.avatar.length === 0;
    var wechatQRCode = props.wechatQRCode && props.wechatQRCode.length > 0 ? props.wechatQRCode : ossGen("hy-qrcode.png");
    // 微信二维码
    var wechatPopover = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((person_area_index_module_default()).popWechat, " flex-row-center"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            style: {
                width: 200,
                height: 200
            },
            src: wechatQRCode,
            alt: ""
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (person_area_index_module_default()).container,
        style: props.style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-row flex-cross-axis-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        style: {
                            borderRadius: noAvatar ? 0 : undefined
                        },
                        className: (person_area_index_module_default()).avatar,
                        src: noAvatar ? (logo512_default()) : props.avatar,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (person_area_index_module_default()).name,
                                children: props.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (person_area_index_module_default()).phone,
                                children: [
                                    "联系电话：",
                                    props.phone
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    marginTop: 32
                },
                className: "flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* default */.Z, {
                        placement: "top",
                        content: wechatPopover,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                marginRight: 8,
                                border: "1px solid #FFC400"
                            },
                            className: "".concat((person_area_index_module_default()).button, " flex-row-center"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (wechat_default()),
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: "#FFC400"
                                    },
                                    children: "微信联系"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            border: "1px solid #00A7EB"
                        },
                        className: "".concat((person_area_index_module_default()).button, " flex-row-center"),
                        onClick: onTapContact,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (chat_default()),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    color: "#00A7EB"
                                },
                                children: "在线咨询"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var person_area = (TMDetailPersonArea);

// EXTERNAL MODULE: ./modules/tm/components/detail/header-info/picture-area/index.module.scss
var picture_area_index_module = __webpack_require__(49927);
var picture_area_index_module_default = /*#__PURE__*/__webpack_require__.n(picture_area_index_module);
// EXTERNAL MODULE: ./modules/tm/assets/detail/safe-shield.png
var safe_shield = __webpack_require__(46661);
var safe_shield_default = /*#__PURE__*/__webpack_require__.n(safe_shield);
;// CONCATENATED MODULE: ./modules/tm/components/detail/header-info/picture-area/index.tsx




var TMDetailPictureArea = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((picture_area_index_module_default()).container, " flex-col flex-cross-axis-center"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (picture_area_index_module_default()).mainPicture,
                src: props.mainPicture,
                alt: props.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((picture_area_index_module_default()).noticeContainer, " flex-row flex-cross-axis-center"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (picture_area_index_module_default()).safeIcon,
                        src: (safe_shield_default()),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (picture_area_index_module_default()).text,
                        children: "国家商标局备案机构，安全保障"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var picture_area = (TMDetailPictureArea);

// EXTERNAL MODULE: ./modules/tm/components/detail/header-info/price-area/index.module.scss
var price_area_index_module = __webpack_require__(25650);
var price_area_index_module_default = /*#__PURE__*/__webpack_require__.n(price_area_index_module);
// EXTERNAL MODULE: ./modules/tm/assets/detail/price.png
var price = __webpack_require__(15297);
var price_default = /*#__PURE__*/__webpack_require__.n(price);
;// CONCATENATED MODULE: ./modules/tm/components/detail/header-info/price-area/index.tsx







var TMDetailPriceArea = function(props) {
    var router = (0,next_router.useRouter)();
    var getPrice = (0,react.useCallback)(function(value) {
        if (value >= 10000) return (value / 10000).toFixed(2);
        else return value.toFixed(0);
    }, []);
    var onTapLogin = (0,react.useCallback)(function() {
        router.push(app_router/* default.User.login */.Z.User.login({
            redirect: window.location.href
        }));
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((price_area_index_module_default()).container, " flex-col flex-main-axis-between"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-row flex-cross-axis-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (price_area_index_module_default()).priceIcon,
                        src: (price_default()),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (price_area_index_module_default()).title,
                        children: "出售价格"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-row flex-cross-axis-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TMDetailCtx.Consumer, {
                        children: function(value) {
                            return value.hasLogin ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (price_area_index_module_default()).price,
                                children: [
                                    "￥",
                                    getPrice(props.price),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: props.price >= 10000 ? "万" : "元"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (price_area_index_module_default()).loginNotice,
                                onClick: onTapLogin,
                                children: "登录获取价格"
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (price_area_index_module_default()).line
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (price_area_index_module_default()).title,
                        style: {
                            marginRight: 10
                        },
                        children: "预付定金"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (price_area_index_module_default()).value,
                        children: [
                            "￥",
                            getPrice(props.deposit),
                            props.deposit >= 10000 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "万"
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (price_area_index_module_default()).line
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (price_area_index_module_default()).title,
                        style: {
                            marginRight: 10
                        },
                        children: "服务费"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (price_area_index_module_default()).value,
                        children: "".concat(props.serviceRatio * 100, "%")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var price_area = (TMDetailPriceArea);

// EXTERNAL MODULE: ./node_modules/antd/es/typography/index.js + 19 modules
var typography = __webpack_require__(56075);
// EXTERNAL MODULE: ./modules/tm/components/detail/header-info/title-area/index.module.scss
var title_area_index_module = __webpack_require__(70925);
var title_area_index_module_default = /*#__PURE__*/__webpack_require__.n(title_area_index_module);
;// CONCATENATED MODULE: ./modules/tm/components/detail/header-info/title-area/index.tsx




var TMDetailTitleArea = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (title_area_index_module_default()).title,
                children: props.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (title_area_index_module_default()).info,
                        children: "组合类型：".concat(props.type)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((title_area_index_module_default()).info, " flex-row"),
                        children: [
                            "商品编号：",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* default.Paragraph */.Z.Paragraph, {
                                copyable: true,
                                className: (title_area_index_module_default()).info,
                                style: {
                                    color: "#999999",
                                    marginBottom: 0
                                },
                                children: props.code
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var title_area = (TMDetailTitleArea);

;// CONCATENATED MODULE: ./modules/tm/components/detail/header-info/index.tsx









var TMDetailHeaderInfo = function(props) {
    var model = props.model;
    var person = model.spreadPerson;
    var photo = model.extend.photo;
    if (model.renderPhoto) photo = model.renderPhoto;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((header_info_index_module_default()).section, " flex-row"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_area, {
                name: model.name,
                mainPicture: photo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((header_info_index_module_default()).rightContainer, " flex-col"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(title_area, {
                        name: model.name,
                        code: model.code,
                        type: (ref = tm_defines/* default.GetTMRegTypeValue */.ZP.GetTMRegTypeValue(model.type)) !== null && ref !== void 0 ? ref : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(price_area, {
                        price: model.price,
                        deposit: model.price * 0.2,
                        serviceRatio: 0.05
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-row",
                        style: {
                            flex: 1,
                            marginTop: 20
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(info_area, {
                                code: model.code,
                                category: model.classify,
                                subCategory: model.subClassify
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (header_info_index_module_default()).line
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(person_area, {
                                style: {
                                    flex: "1"
                                },
                                avatar: person === null || person === void 0 ? void 0 : person.avatar,
                                name: person === null || person === void 0 ? void 0 : person.name,
                                phone: person === null || person === void 0 ? void 0 : person.mobile,
                                wechatQRCode: person === null || person === void 0 ? void 0 : person.wechatQRCode
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var header_info = (TMDetailHeaderInfo);

// EXTERNAL MODULE: ./modules/tm/components/detail/basic-info/index.module.scss
var basic_info_index_module = __webpack_require__(38013);
var basic_info_index_module_default = /*#__PURE__*/__webpack_require__.n(basic_info_index_module);
;// CONCATENATED MODULE: ./modules/tm/components/detail/basic-info/index.tsx




var TMDetailBasicInfo = function(props) {
    var model = props.model;
    var extend = model.extend;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (basic_info_index_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((basic_info_index_module_default()).header, " flex-row flex-cross-axis-center"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "基本信息"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (basic_info_index_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (basic_info_index_module_default()).item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basic_info_index_module_default()).title,
                                        children: "初审公告期号："
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basic_info_index_module_default()).value,
                                        children: extend.announcementIssue
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (basic_info_index_module_default()).item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basic_info_index_module_default()).title,
                                        children: "初审公告日期："
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basic_info_index_module_default()).value,
                                        children: extend.announcementDate
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (basic_info_index_module_default()).item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basic_info_index_module_default()).title,
                                        children: "组合类型："
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basic_info_index_module_default()).value,
                                        children: tm_defines/* default.GetTMRegTypeValue */.ZP.GetTMRegTypeValue(model.type)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (basic_info_index_module_default()).item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basic_info_index_module_default()).title,
                                        children: "有效期限："
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basic_info_index_module_default()).value,
                                        children: "".concat(extend.privateStartDate, " 至 ").concat(extend.privateEndDate)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-row",
                        style: {
                            marginTop: 20
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (basic_info_index_module_default()).item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basic_info_index_module_default()).title,
                                        children: "注册公告期号："
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basic_info_index_module_default()).value,
                                        children: extend.registerIssue
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (basic_info_index_module_default()).item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basic_info_index_module_default()).title,
                                        children: "注册公告日期："
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (basic_info_index_module_default()).value,
                                        children: extend.registerDate
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var basic_info = (TMDetailBasicInfo);

// EXTERNAL MODULE: ./modules/tm/components/detail/transfer-data/index.module.scss
var transfer_data_index_module = __webpack_require__(48821);
var transfer_data_index_module_default = /*#__PURE__*/__webpack_require__.n(transfer_data_index_module);
;// CONCATENATED MODULE: ./modules/tm/components/detail/transfer-data/index.tsx




var TMDetailTransferData = function(props) {
    // 信息列创建
    var createInfoRow = (0,react.useCallback)(function(title, values, width) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                width: width,
                height: 270,
                flex: width === undefined ? 1 : undefined
            },
            className: "flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: 70
                    },
                    className: "".concat((transfer_data_index_module_default()).title, " flex-row-center"),
                    children: title
                }),
                values.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((transfer_data_index_module_default()).value, " flex-row-center"),
                        children: item
                    }, index);
                })
            ]
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (transfer_data_index_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((transfer_data_index_module_default()).header, " flex-row flex-cross-axis-center flex-main-axis-between"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "过户资料"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-row flex-cross-axis-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (transfer_data_index_module_default()).icon,
                                src: (safe_shield_default()),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (transfer_data_index_module_default()).notice,
                                children: "资料齐全，真实可靠，保障交易安全"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (transfer_data_index_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-row",
                        children: [
                            createInfoRow("主体资料", [
                                "自然人",
                                "企业"
                            ], 132),
                            createInfoRow("受让方提供", [
                                "身份证\n个体户营业执照",
                                "企业营业执照"
                            ], 180),
                            createInfoRow("转让方提供", [
                                "身份证“正反”两面复印件\n商标注册证原件",
                                "企业营业执照\n商标注册证原件"
                            ], 234),
                            createInfoRow("平台提供", [
                                "转让申请书\n代理委托书\n转让协议书\n商标使用授权书"
                            ], 234),
                            createInfoRow("过户后，受让方可获得官方证件", [
                                "商标注册证原件\n商标转让受理回执\n商标转让证明"
                            ])
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (transfer_data_index_module_default()).notice,
                        children: '以上资料均须提供电子档，转让注册商标，3-7个工作日左右办理好转让手续，获得"商标使用授权书"即日可以打R使用，安全无风险。\n转让注册商标经核准后，予以公告。受让人自公告之日起享有商标专用权。'
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var transfer_data = (TMDetailTransferData);

// EXTERNAL MODULE: ./common/components/page-header/index.tsx + 1 modules
var page_header = __webpack_require__(61054);
// EXTERNAL MODULE: ./common/components/page-footer/index.tsx
var page_footer = __webpack_require__(82468);
;// CONCATENATED MODULE: ./pages/tm-detail/[code].tsx























var Api = tm/* default.Api */.Z.Api;
var __N_SSP = true;
var TMDetailCtx = /*#__PURE__*/ react.createContext({});
var TMDetailPage = function(props) {
    var model = new tm_model/* default */.ZP(props.modelData);
    var router = (0,next_router.useRouter)();
    var ref = (0,redux/* useAppSelector */.CG)(function(state) {
        var ref;
        return {
            state: state.user,
            hasLogin: ((ref = state._persist) === null || ref === void 0 ? void 0 : ref.rehydrated) && state.user.user !== undefined
        };
    }), state = ref.state, hasLogin = ref.hasLogin;
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(), ctxValue = ref2[0], setCtxValue = ref2[1];
    (0,react.useEffect)(function() {
        setCtxValue({
            state: state,
            hasLogin: hasLogin
        });
    }, [
        state,
        hasLogin
    ]);
    // 请求 - 购买商标，创建订单
    var requestBuy = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(code) {
            var response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            Api.Order.create(code)
                        ];
                    case 1:
                        response = _state.sent();
                        setLoading(false);
                        if (!response.success) {
                            message/* default.error */.ZP.error(response.errorDescribe);
                            return [
                                2
                            ];
                        }
                        message/* default.success */.ZP.success("下单成功", 1, function() {
                            router.push(app_router/* default.User.Center.order */.Z.User.Center.order);
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(code) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router
    ]);
    // 点击了购买商标
    var onTapBuy = (0,react.useCallback)(function(code) {
        requestBuy(code);
    }, [
        requestBuy
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).page,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head/* default */.Z, {
                title: model.name,
                description: "".concat(model.name, ",").concat(model.uiCategory, ",").concat(model.uiScope),
                keywords: "".concat(model.name, ",").concat(model.uiCategory)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (index_module_default()).naviHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(page_header/* default */.Z, {
                    mode: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                spinning: loading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).section,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((index_module_default()).breadMenu, " flex-row flex-cross-axis-center flex-main-axis-between"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(breadcrumb/* default */.Z, {
                                    separator: ">",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(breadcrumb/* default.Item */.Z.Item, {
                                            href: app_router/* default.User.Center.home */.Z.User.Center.home,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeOutlined/* default */.Z, {
                                                    style: {
                                                        marginRight: 5
                                                    }
                                                }),
                                                "首页"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default.Item */.Z.Item, {
                                            href: app_router/* default.TM.transfer */.Z.TM.transfer({
                                                c: model.classify
                                            }),
                                            children: model.uiCategory
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default.Item */.Z.Item, {
                                            children: model.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(top_info/* default */.Z, {
                                    style: {
                                        padding: 0,
                                        border: "none"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TMDetailCtx.Provider, {
                            value: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ctxValue), {
                                onTapBuy: onTapBuy
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_info, {
                                model: model
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(basic_info, {
                            model: model
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transfer_data, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(not_found/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(recommend/* default */.Z, {
                            hasLogin: hasLogin
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(page_footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var _code_ = (TMDetailPage);


/***/ }),

/***/ 38013:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2b88ff","colorPrimaryEnd":"#1955a8","colorBg":"#f5f5f5","colorText1":"#333","colorText2":"#666","colorText3":"#999","container":"basic-info_container__IJIQ4","header":"basic-info_header__zgO1V","content":"basic-info_content__w4Te9","item":"basic-info_item__2RfKG","title":"basic-info_title__UousV","value":"basic-info_value__aJR9d"};

/***/ }),

/***/ 70311:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2b88ff","colorPrimaryEnd":"#1955a8","colorBg":"#f5f5f5","colorText1":"#333","colorText2":"#666","colorText3":"#999","section":"header-info_section__U_saO","rightContainer":"header-info_rightContainer__L_5I_","line":"header-info_line__tjJVL"};

/***/ }),

/***/ 74337:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2b88ff","colorPrimaryEnd":"#1955a8","colorBg":"#f5f5f5","colorText1":"#333","colorText2":"#666","colorText3":"#999","container":"info-area_container__inttq","info":"info-area_info__OX7qw","title":"info-area_title__yQolM","value":"info-area_value__K6cXP","notice":"info-area_notice__aPfGu","buttonContainer":"info-area_buttonContainer__D3ikH","button":"info-area_button__qIBVI","buttonContact":"info-area_buttonContact__sw8hj","buttonBuy":"info-area_buttonBuy__E9dcM"};

/***/ }),

/***/ 38146:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2b88ff","colorPrimaryEnd":"#1955a8","colorBg":"#f5f5f5","colorText1":"#333","colorText2":"#666","colorText3":"#999","container":"person-area_container__vxME8","avatar":"person-area_avatar__wxyR0","name":"person-area_name__qnBzH","phone":"person-area_phone__zupMS","button":"person-area_button__UOonu"};

/***/ }),

/***/ 49927:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2b88ff","colorPrimaryEnd":"#1955a8","colorBg":"#f5f5f5","colorText1":"#333","colorText2":"#666","colorText3":"#999","container":"picture-area_container__LcMjd","mainPicture":"picture-area_mainPicture__255Kr","noticeContainer":"picture-area_noticeContainer__v_9Pp","safeIcon":"picture-area_safeIcon__t9Kzg","text":"picture-area_text__eUw5c"};

/***/ }),

/***/ 25650:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2b88ff","colorPrimaryEnd":"#1955a8","colorBg":"#f5f5f5","colorText1":"#333","colorText2":"#666","colorText3":"#999","container":"price-area_container__Chn4O","priceIcon":"price-area_priceIcon__rehEB","title":"price-area_title__sKAcj","price":"price-area_price__RH_hd","loginNotice":"price-area_loginNotice__PJLEE","loginNoticeSize":"price-area_loginNoticeSize__Suv0M","value":"price-area_value__2osUV","line":"price-area_line__M3j81"};

/***/ }),

/***/ 70925:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2b88ff","colorPrimaryEnd":"#1955a8","colorBg":"#f5f5f5","colorText1":"#333","colorText2":"#666","colorText3":"#999","title":"title-area_title__orYyo","info":"title-area_info__r_HQI"};

/***/ }),

/***/ 48821:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2b88ff","colorPrimaryEnd":"#1955a8","colorBg":"#f5f5f5","colorText1":"#333","colorText2":"#666","colorText3":"#999","container":"transfer-data_container__ZwhXT","header":"transfer-data_header__ZCI5Q","icon":"transfer-data_icon___EjD9","notice":"transfer-data_notice__Qe4FR","content":"transfer-data_content__2rm_Y","title":"transfer-data_title__tCiKd","value":"transfer-data_value__Ges99"};

/***/ }),

/***/ 49571:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2b88ff","colorPrimaryEnd":"#1955a8","colorBg":"#f5f5f5","colorText1":"#333","colorText2":"#666","colorText3":"#999","item":"item_item__MSjRj","content":"item_content__oTJWA","logo":"item_logo__kekbv","nameContainer":"item_nameContainer___0TKl","name":"item_name__RqAQK","tag":"item_tag__3hpcG","desc":"item_desc__e_d9M","row4":"item_row4__Ta3Ru","price":"item_price__1QJPd","buttonContainer":"item_buttonContainer__s__5U","contactNow":"item_contactNow__Bmpc_","getPrice":"item_getPrice___rkm5","modalContainer":"item_modalContainer__pGMPo","title":"item_title__cdNKa","card":"item_card__SE_OR","category":"item_category__VaZAI","scope":"item_scope__3OVQk"};

/***/ }),

/***/ 35854:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2b88ff","colorPrimaryEnd":"#1955a8","colorBg":"#f5f5f5","colorText1":"#333","colorText2":"#666","colorText3":"#999","container":"not-found_container___a2zS","logo":"not-found_logo__HMLRn","infoContainer":"not-found_infoContainer__F6WHq","btnContainer":"not-found_btnContainer__YUeJW","btn":"not-found_btn__4SE42","icon":"not-found_icon__lQIlu"};

/***/ }),

/***/ 34418:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2b88ff","colorPrimaryEnd":"#1955a8","colorBg":"#f5f5f5","colorText1":"#333","colorText2":"#666","colorText3":"#999","container":"recommend_container__V1SCu","listContainer":"recommend_listContainer__UceCI"};

/***/ }),

/***/ 23749:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2b88ff","colorPrimaryEnd":"#1955a8","colorBg":"#f5f5f5","colorText1":"#333","colorText2":"#666","colorText3":"#999","container":"top-info_container__anl6W","infoItem":"top-info_infoItem__Mf9hT","icon":"top-info_icon__z52RS","title":"top-info_title__JJqTD","value":"top-info_value__OVqVi","arrow":"top-info_arrow___i3T8"};

/***/ }),

/***/ 64460:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2b88ff","colorPrimaryEnd":"#1955a8","colorBg":"#f5f5f5","colorText1":"#333","colorText2":"#666","colorText3":"#999","page":"tm-detail_page__thDkZ","naviHeader":"tm-detail_naviHeader__uSVWP","section":"tm-detail_section__YktGu","breadMenu":"tm-detail_breadMenu__xuHq5"};

/***/ }),

/***/ 67627:
/***/ (function(module) {

module.exports = "/_next/static/media/1e8ffd2739488621a717461cc117f4c1.png";

/***/ }),

/***/ 33984:
/***/ (function(module) {

module.exports = "/_next/static/media/016e29656c6da8778f08df22d079b3d0.png";

/***/ }),

/***/ 83285:
/***/ (function(module) {

module.exports = "/_next/static/media/c705c85edec1c329f88a852106538144.png";

/***/ }),

/***/ 15297:
/***/ (function(module) {

module.exports = "/_next/static/media/d4e894ccf4d68799ea74f7933d0b1350.png";

/***/ }),

/***/ 46661:
/***/ (function(module) {

module.exports = "/_next/static/media/02f962776f08092120336a3ddd37d321.png";

/***/ }),

/***/ 91585:
/***/ (function(module) {

module.exports = "/_next/static/media/3715024d8c99501a1fe264405a1a34e4.png";

/***/ }),

/***/ 59161:
/***/ (function(module) {

module.exports = "/_next/static/media/0d85952632c7602ecea7b517b29f3fb7.png";

/***/ }),

/***/ 95406:
/***/ (function(module) {

module.exports = "/_next/static/media/e4f15af4bd85303bbfa85f253d0d7ac3.png";

/***/ }),

/***/ 73518:
/***/ (function(module) {

module.exports = "/_next/static/media/5a69795a00e712d993effb25d0f8a00f.png";

/***/ }),

/***/ 82064:
/***/ (function(module) {

module.exports = "/_next/static/media/04b38a2663f56a4c87cb0e4e18415c5c.png";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5241,173,9291,226,6075,6084,9774,2888,179], function() { return __webpack_exec__(49312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);